<template>
  <div>
    <BemVindo></BemVindo>
    <Dashboard></Dashboard>
  </div>
</template>

<script>
  import { mapMutations } from "vuex";
  import BemVindo from './BemVindo';
  import Dashboard from './Dashboard';

  export default {
    name: 'Home',

    components: {
      BemVindo,
      Dashboard
    },

    data() {
      return {
        data: null,
      }
    },
    mounted() {
      this.setTitulo('Dashboard');
    },
    methods: {
      ...mapMutations(['setTitulo']),
    }
  }
</script>

<style scoped>
  .input-trasparente >>> .v-input__slot {
    background: none;
  }
</style>
